import React from 'react';

const Component = props => {
	return (
		<>
			<div className='pt-[5px]'>
				<h2 className='text-[36px] text-[#282e3f] mb-[25px]'>Droit de la circulation routière</h2>
			</div>
			<div className='mt-[30px]'>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet GAVA-<i>Lex</i> vous conseillera et vous défendra dans tous les dossiers en matière de
					circulation routière (amendes et infractions au <strong>Code de la route</strong>, tribunal de
					police, accident, etc..).
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Si vous avez reçu une amende ou un procès-verbal liés à un <strong>excès de vitesse</strong>, à
					toute autre contravention ou à une consommation d'<strong>alcool</strong>, de{' '}
					<strong>stupéfiants</strong> et/ou de médicaments, etc..., le cabinet vous conseillera et vous
					aidera à contester l'infraction si possible.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Le cabinet peut également vous assister au cours d'une audition lorsque vous êtes entendu en qualité
					de victime ou de suspect d'une infraction de roulage.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Si vous êtes cité devant le <strong>tribunal de police</strong>, le cabinet vous assistera en vue de
					réduire au maximum les peines, solliciter des mesures de faveur (comme la suspension du prononcé),
					et vous expliquer le déroulement de la procédure.
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Si vous êtes victime ou responsable d'un <strong>accident de la route</strong>, le cabinet vous
					accompagnera au mieux en vue de préserver vos droits et intérêts. Si vous êtes victime d'un accident
					de la circulation, le cabinet vous aidera à introduire une procédure devant le tribunal de police en
					vue d'obtenir indemnisation de votre <strong>préjudice</strong> (véhicule, blessures, décès).
				</p>
				<p className='text-[#666] text-[15px] leading-[28px] mb-[16px]'>
					Si votre compagnie d'assurances se retourner contre vous (action récursoire pour{' '}
					<strong>ivresse</strong>, <strong>défaut de permis de conduire</strong> ou de contrôle technique,
					etc...), le cabinet vous conseillera et vous défendra au mieux en vue de sauvegarder vos intérêts.
				</p>

				<div className='organigation-text w-[80%] col:float-none  col:w-full mt-[30px]'>
					<h2 className='text-[24px] text-[#282e3f] mb-[8px] block'>Aperçu des Cas Pratiques : </h2>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Amendes et infractions routières
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Défense devant le tribunal de police
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Assistance en cas d'accident de la route
					</span>
					<span className='block pt-[15px] text-[15px] text-[#333]'>
						<i className='fa fa-check-square-o text-[#c0b596] pr-[15px]' aria-hidden='true'></i>
						Action récursoire - Recours de la compagnie d'assurances contre vous
					</span>
				</div>
			</div>
		</>
	);
};

export default Component;
